// extracted by mini-css-extract-plugin
export default {"card":"M3-z"};